import { Component, OnInit } from "@angular/core";
import { Advancedfilters } from "../../models/usuario-mantenimiento";
import { AdvancedFiltersService } from "src/app/core/services/advancedFilters.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { TokenService } from "src/app/core/services/token.service";
import { AppConstants } from "src/app/constants/app.constants";

@Component({
  selector: "app-advanced-filters",
  templateUrl: "./advanced-filters.component.html",
  styleUrls: ["./advanced-filters.component.scss"],
})
export class AdvancedFiltersComponent implements OnInit {
  public roles = AppConstants.roles;
  public catalogList = {
    cocList: {
      list: null,
      values: [],
      conf: {
        id: "id",
        text: "faDescripcion",
      },
    },
    certificatesList: {
      list: null,
      values: [],
      conf: {
        id: "id",
        text: "faDescripcion",
      },
    },
    placaList: {
      list: null,
      values: [],
      conf: {
        id: "id",
        text: "faDescripcion",
      },
    },
    loaded: false,
  };
  public catalogByUser = {
    certificatesloaded: false,
    cocLoaded: false,
    placaLoaded: false,
    certificatesList: null,
    cocList: null,
    placaList: null,
  };

  constructor(
    private advancedFiltersService: AdvancedFiltersService,
    private toastrAlertService: ToastrAlertService,
    private sweetAlertService: SweetAlertService,
    private tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.getAdvancedFiltersCatalog();
    this.getFiltersByUser("COC");
    this.getFiltersByUser("CERTIFICADO");
    this.getFiltersByUser("PLACA");
  }

  getAdvancedFiltersCatalog() {
    this.advancedFiltersService.getCatalogo().subscribe(
      (data) => {
        this.catalogList.loaded = true;
        this.catalogList.certificatesList.list = data.filter(
          (e) => e.id.faTiposolicitud == "CERTIFICADO"
        );
        this.catalogList.cocList.list = data.filter(
          (e) => e.id.faTiposolicitud == "COC"
        );
        this.catalogList.placaList.list = data.filter(
          (e) => e.id.faTiposolicitud == "PLACA"
        );
        if (this.catalogByUser.certificatesloaded) {
          this.setValuesOfAdvantedFilters(
            this.catalogByUser.certificatesList,
            this.catalogList.certificatesList.list,
            "CERTIFICADO"
          );
        }
        if (this.catalogByUser.cocLoaded) {
          this.setValuesOfAdvantedFilters(
            this.catalogByUser.cocList,
            this.catalogList.cocList.list,
            "COC"
          );
        }
        if (this.catalogByUser.placaLoaded) {
          this.setValuesOfAdvantedFilters(
            this.catalogByUser.placaList,
            this.catalogList.placaList.list,
            "PLACA"
          );
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  checkItem(item) {
    item["checked"] = item["checked"] ? false : true;
  }
  castToDtoFilters(catalogList): Advancedfilters[] {
    let catalogListToSend: Advancedfilters[];
    catalogListToSend = this.addToFinalArray(
      catalogList.certificatesList,
      "CERTIFICADO"
    );
    catalogListToSend = [
      ...catalogListToSend,
      ...this.addToFinalArray(catalogList.cocList, "COC"),
    ];
    catalogListToSend = [
      ...catalogListToSend,
      ...this.addToFinalArray(catalogList.placaList, "PLACA"),
    ];
    return catalogListToSend;
  }

  addToFinalArray(catalogList, type: string): Advancedfilters[] {
    let catalogListToSend: Advancedfilters[] = [];
    catalogList.list.forEach((element) => {
      const matchFilter = (e) => element.id.faFiltro == e.id.faFiltro;
      let index = catalogList.values.findIndex(matchFilter);
      let elementCatalogList: Advancedfilters;
      if (index > -1) {
        elementCatalogList = {
          ufActivo: "S",
          ufFiltro: element.id.faFiltro,
          ufTiposolicitud: type,
        };
      } else {
        elementCatalogList = {
          ufActivo: "N",
          ufFiltro: element.id.faFiltro,
          ufTiposolicitud: type,
        };
      }
      catalogListToSend.push(elementCatalogList);
    });
    return catalogListToSend;
  }

  onSave() {
    this.sweetAlertService.sweetAlertLoading();
    this.advancedFiltersService
      .saveFilters(this.castToDtoFilters(this.catalogList))
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          this.tokenService.redirectPredefinedMailBox();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  getFiltersByUser(type: string) {
    this.advancedFiltersService.getAdvancedFiltersByUser(type).subscribe(
      (data) => {
        switch (type) {
          case "CERTIFICADO":
            this.catalogByUser.certificatesList = data;
            this.catalogByUser.certificatesloaded = true;
            if (this.catalogList.loaded) {
              this.setValuesOfAdvantedFilters(
                data,
                this.catalogList.certificatesList.list,
                type
              );
            }
            break;
          case "COC":
            this.catalogByUser.cocList = data;
            this.catalogByUser.cocLoaded = true;
            if (this.catalogList.loaded) {
              this.setValuesOfAdvantedFilters(
                data,
                this.catalogList.cocList.list,
                type
              );
            }
            break;
          case "PLACA":
            this.catalogByUser.placaList = data;
            this.catalogByUser.placaLoaded = true;
            if (this.catalogList.loaded) {
              this.setValuesOfAdvantedFilters(
                data,
                this.catalogList.placaList.list,
                type
              );
            }
            break;
          default:
            break;
        }
      },
      (err) => {
        switch (type) {
          case "CERTIFICADO":
            this.catalogByUser.certificatesList = [];
            this.catalogByUser.certificatesloaded = true;

            break;
          case "COC":
            this.catalogByUser.cocList = [];
            this.catalogByUser.cocLoaded = true;

            break;
          case "PLACA":
            this.catalogByUser.placaList = [];
            this.catalogByUser.placaLoaded = true;

            break;
          default:
            break;
        }
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  setValuesOfAdvantedFilters(data, catalogList, type: string) {
    data.forEach((element) => {
      const matchFilter = (e) => element.id.ufFiltro == e.id.faFiltro;
      let index = catalogList.findIndex(matchFilter);
      if (index > -1) {
        catalogList[index]["checked"] = element.ufActivo == "S" ? true : false;
        if (element.ufActivo == "S") {
          switch (type) {
            case "COC":
              this.catalogList.cocList.values.push(catalogList[index]);
              break;
            case "PLACA":
              this.catalogList.placaList.values.push(catalogList[index]);
              break;
            case "CERTIFICADO":
              this.catalogList.certificatesList.values.push(catalogList[index]);
          }
        }
      }
    });
  }

  sendValue(value: any, type: string) {
    switch (type) {
      case "COC":
        this.catalogList.cocList.values = value.list;
        break;
      case "PLACA":
        this.catalogList.placaList.values = value.list;
        break;
      case "CERTIFICADO":
        this.catalogList.certificatesList.values = value.list;
    }
  }

  isLoaded(): boolean {
    return (
      this.catalogList.loaded &&
      this.catalogByUser.certificatesloaded &&
      this.catalogByUser.cocLoaded &&
      this.catalogByUser.placaLoaded
    );
  }

  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
}
